import { useEffect, useState } from "react";
import RadioGroup from "../../components/Form/RadioGroup";
import Search from "../../components/Form/Search";
import Button from "../../components/Form/Button";
import Modal from "../../components/Elements/Modal";
import BlogsItem from "../../components/Items/BlogsItem";
import AddBlogs from "../../components/Modals/AddBlogs";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { detailsBlog, listBlog, listCategories, ordering } from "../../helpers/api_helper";
import Pagination from "../../components/Elements/Pagination";
import { toast } from "react-toastify";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import moment from "moment/moment";
import Select from "react-select";

const BlogList = ({ queryKey }) => {
  // Query Client instance
  const queryClient = useQueryClient();
  // For pagination
  const [perPages, setPerPages] = useState([
    { label: "10 (Default)", value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
    { label: 100, value: 100 },
    { label: "All", value: 999999 },
  ]);
  const [selectedPageOpt, setSelectedPageOpt] = useState([]);

  // For Managing Modals
  const [isAddModal, setIsAddModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);

  const [isOne, setDataOne] = useState(false);

  //Data
  const [dataList, setDataList] = useState([]);

  // For Filtering Data 🔍
  const [keyword, setKeyword] = useState("");
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [status, setStatus] = useState("");
  const [selectedCatOpt, setSelectedCatOpt] = useState([]);
  const [selectedCat, setSelectedCat] = useState([]);
  const [category_id, setCategory_id] = useState("");

  // To fetch Details of specific items when it needs to be edited
  const [alias, setAlias] = useState("");

  // Static status Radio buttons
  const [statusStatic, setStatusStatic] = useState([
    { _id: "", name: "All", color: "success", current: true },
    { _id: true, name: "Published", color: "success", current: false },
    { _id: false, name: "Draft", color: "warning", current: false },
  ]);

  // Dynamic query key for Blogs 🗝️
  const queryBlogs = ["Blogs", keyword, status, limit, offset, category_id];

  // For opening Add Modal althogh not mandetory
  const addModal = () => {
    setIsAddModal(true);
  };

  // For fetching details of item
  const {
    data: details,
    error,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ["details", alias],
    queryFn: async () => detailsBlog({ alias: alias }),
    enabled: false,
  });

  // Refetch when editId updates
  useEffect(() => {
    if (alias !== "" && isEditModal) {
      refetch();
    }
  }, [alias, refetch, isEditModal]);

  // Blog List Component
  function BlogList() {
    // Custom hook for fetching blog list
    function useBlog() {
      return useQuery({
        queryKey: queryBlogs,
        queryFn: () =>
          listBlog({
            keyword: keyword,
            sortByField: "ordering",
            sortByValue: 1,
            status: status,
            limit: limit,
            offset: offset,
            category_id: category_id,
          }),
        keepPreviousData: true,
      });
    }

    const { data: blogs, error, isFetching } = useBlog();

    useEffect(() => {
      if (!isOne) {
        setDataList(blogs?.data);
      }
    }, [isOne, blogs?.data]);

    const handleDragEnd = (e) => {
      //console.log(e);
      if (!e.destination) return;
      let tempData = Array.from(dataList);
      let [source_data] = tempData.splice(e.source.index, 1);
      tempData.splice(e.destination.index, 0, source_data);
      // console.log(tempData);
      setDataList([...tempData]);
      let dataArray = [];
      for (let i = 0; i < tempData.length; i++) {
        dataArray.push({ id: tempData[i]._id, ordering: i + 1 });
      }
      // setOrderingData(dataArray);
      onClickSaveOrdering(dataArray);
      setDataOne(true);
    };

    const onClickSaveOrdering = async (orderingData) => {
      const saveOrdering = await ordering({
        orderingData: orderingData,
        tableName: "blog",
      });

      if (saveOrdering.status === 200) {
        setDataOne(false);
        queryClient.invalidateQueries(queryBlogs);
        queryClient.removeQueries({
          queryKey: ["Blogs"],
          type: "inactive",
        });
        toast.success(saveOrdering.message);
      } else {
        toast.error(saveOrdering.message);
      }
    };

    // Handling loading state 😑
    if (isFetching) {
      return (
        <div className="noresult">
          <div className="text-center">
            <div className="fa-solid fa-circle-notch fa-spin"></div>
          </div>
        </div>
      );
    }

    // Handling error state 🥴
    if (error) {
      return <div>Something went wrong 🫥</div>;
    }

    // Check if their is no data 🤨
    else if (blogs.data.length === 0) {
      return (
        <div className="noresult">
          <div className="text-center">
            <h5 className="mt-2">Sorry! No Result Found</h5>
          </div>
        </div>
      );
    }

    // Renders the list
    else {
      return (
        // For Pagination
        <>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {dataList &&
                    dataList.length > 0 &&
                    dataList.map((item, index) => (
                      <BlogsItem
                        key={item._id}
                        alias={item?.alias}
                        index={index}
                        BlogId={item._id}
                        name={item?.title}
                        author={item?.authors_details?.name}
                        createdDate={moment(new Date(item?.created_at)).format(
                          "Do MMM YY"
                        )}
                        updatedDate={moment(new Date(item?.updated_at)).format(
                          "Do MMM YY"
                        )}
                        query={queryKey}
                        status={item?.status}
                        detailsFetch={refetch}
                        // setEditId={setEditId}
                        setalias={setAlias}
                        setEditModal={setIsEditModal}
                      />
                    ))}

                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <Pagination
            count={blogs.count}
            limit={limit}
            offset={offset}
            setOffset={setOffset}
          />
        </>
      );
    }
  }

  function useCategory() {
    return useQuery({
      queryKey: ["blogs_categories_dropdown"],
      queryFn: async () => {
        let tmp = [];
        const { data } = await listCategories(
          {
            limit: 9999,
            category_type: "blogs",
          }
        );

        data.forEach((item) => {
          tmp.push({ value: item._id, label: item.name });
        });

        return tmp;
      },
    });
  }

  const { data: categories } = useCategory();

  return (
    <>
      <div className="page-filter mb-3">
        <div className="input-filters">
          <div className="input-items">
            {perPages && (
              <div className="input">
                <Select
                  className="select-tag"
                  isMulti={false}
                  isClearable={true}
                  options={perPages}
                  value={selectedPageOpt || []}
                  placeholder={"Per Page"}
                  onChange={(e) => {
                    setLimit(e.value);
                    setSelectedPageOpt(e);
                  }}
                />
              </div>
            )}
          </div>
          <div className="input-items">
            <Search
              state={keyword}
              setState={setKeyword}
              placeholder={"Search..."}
            />
          </div>
          <div className="input-items">
            {categories && (
              <div className="input">
                <Select
                  className="select-tag"
                  isMulti={false}
                  isClearable={true}
                  options={categories}
                  value={selectedCatOpt || []}
                  placeholder={"Categories"}
                  onChange={(e) => {
                    setCategory_id(e.value);
                    setSelectedCatOpt(e);
                  }}
                />
              </div>
            )}
          </div>

          <div className="input-items items-end ms-auto gap-3">
            <Button
              classes={"px-2"}
              icon={"fa-regular fa-arrow-rotate-right"}
              iconPosition={"left"}
              functions={() => {
                queryClient.invalidateQueries(queryBlogs);
                queryClient.removeQueries({
                  queryKey: ["Blogs"],
                  type: "inactive",
                });
                setOffset(0);
                setKeyword("");
                setStatus("");
                setStatusStatic([]);
                setSelectedCatOpt([]);
                setTimeout(() => {
                  setStatusStatic([
                    { _id: "", name: "All", color: "success", current: true },
                    {
                      _id: true,
                      name: "Published",
                      color: "success",
                      current: false,
                    },
                    {
                      _id: false,
                      name: "Draft",
                      color: "warning",
                      current: false,
                    },
                  ]);
                }, 300);
              }}
            />
            <Button
              label={"Add Blogs"}
              labelClasses={""}
              classes={""}
              icon={"fa-regular fa-plus"}
              iconPosition={"left"}
              functions={addModal}
            />
          </div>
        </div>
        <div className="radio-filters">
          <RadioGroup
            data={statusStatic}
            setData={setStatus}
            inputName={"status"}
          />
        </div>
      </div>
      <div className="blogs-list">
        <BlogList
          categoryArray={selectedCat}
          queryKey={queryBlogs}
          limit={limit}
          offset={offset}
          setLimit={setLimit}
          setOffset={setOffset}
          status={status}
        />
      </div>

      {/* // For add Modal */}
      <Modal
        title={"Add Blogs"}
        size={"md"}
        isOpen={isAddModal}
        modalClose={() => setIsAddModal(false)}
      >
        <AddBlogs modalClose={() => setIsAddModal(false)} query={queryBlogs} />
      </Modal>

      {/* //For Edit Modal */}
      <Modal
        title={"Edit Blogs"}
        size={"md"}
        isOpen={isEditModal}
        modalClose={() => setIsEditModal(false)}
      >
        <AddBlogs
          modalClose={() => setIsEditModal(false)}
          query={queryBlogs}
          details={details}
          isFetching={isFetching}
        />
      </Modal>
    </>
  );
};

export default BlogList;
